export default __webpack_public_path__ + "static/media/Eli.9122577e.JPG";